module.exports = __webpack_public_path__ + "static/media/rec1.9bd7ea18.jpg";